import React, { Component } from "react";
import Clone from "../../assets/SvgIcon/Clone/index.js";
import DupontIconButton from "components/DupontIconButton";
import { valueStrings } from "constants/constantStrings";

export default class BaselineCloneRenderer extends Component {
  render() {
    return (
      <DupontIconButton tooltip={valueStrings.clone}>
        <Clone />
      </DupontIconButton>
    );
  }
}
